module.exports = __webpack_public_path__ + "media/images/childcare/main_image2@2x-ff36b41cb5bb3c1c0a8d072234b23f4a.jpg";